import RestApiModel from "@/api/Model/RestApiModel";

class DashboardDataCoverholder extends RestApiModel {
  static getResourceEndpoint() {
    return '/CoverholderDashboardData';
  }
}

export default DashboardDataCoverholder;
